/* eslint-disable react/prop-types */
import React, { FunctionComponent } from "react";
import PropTypes from "prop-types";
import Theme from "../../../theme/theme";
import { StyledBadge } from "./styles";

export interface BadgeProps {
  name: string;
  primary?: boolean;
  secondary?: boolean;
  tertiary?: boolean;
}

export const Badge: FunctionComponent<BadgeProps> = ({
  name,
  primary,
  secondary,
  tertiary,
}) => (
  <Theme>
    <StyledBadge
      data-testid="badge"
      aria-label={name}
      primary={primary}
      secondary={secondary}
      tertiary={tertiary}
    >
      {name}
    </StyledBadge>
  </Theme>
);

Badge.propTypes = {
  name: PropTypes.string.isRequired,
  primary: PropTypes.bool,
  secondary: PropTypes.bool,
  tertiary: PropTypes.bool,
};

Badge.defaultProps = {
  primary: null,
  secondary: null,
  tertiary: null,
};

export default Badge;
